import { useState } from 'react'

// Sits above a day's meal list: apply a previously-saved full-day menu (all
// 5 meal slots at once) to this day, or save this day's current meals as a
// new reusable menu. Mirrors MealEditor's TemplateBar interaction pattern,
// one level up (a whole day's menu instead of a single meal).
export default function CustomMenuBar({ menus, onApply, onSaveCurrent, onDelete }) {
  const [open, setOpen] = useState(false)
  const [saving, setSaving] = useState(false)
  const [name, setName] = useState('')
  const list = Object.entries(menus)

  const confirmSave = () => {
    if (!name.trim()) return
    onSaveCurrent(name.trim())
    setName('')
    setSaving(false)
  }

  return (
    <div className="menu-bar">
      <div className="menu-bar-actions">
        <button className="template-toggle" onClick={() => setOpen((o) => !o)} type="button">
          CUSTOM MENUS ({list.length}) {open ? '▴' : '▾'}
        </button>
        <button className="template-toggle" onClick={() => setSaving((s) => !s)} type="button">
          {saving ? 'CANCEL' : '+ SAVE TODAY AS MENU'}
        </button>
      </div>

      {saving && (
        <div className="template-save-row">
          <input
            type="text"
            className="food-select-input"
            placeholder="Menu name, e.g. High-protein day"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && confirmSave()}
            autoFocus
          />
          <button className="btn btn-primary" onClick={confirmSave} type="button">SAVE</button>
        </div>
      )}

      {open && (
        <div className="template-list">
          {list.length === 0 ? (
            <p className="card-subtitle" style={{ padding: '10px 12px' }}>No saved menus yet - build one below, then "SAVE TODAY AS MENU".</p>
          ) : (
            list.map(([id, menu]) => (
              <div key={id} className="template-row">
                <button className="template-name" onClick={() => { onApply(menu); setOpen(false) }} type="button">{menu.name}</button>
                <button className="template-delete" onClick={() => onDelete(id)} type="button" aria-label="Delete menu">×</button>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  )
}
